import './polyfills';

// Pull wallet stacks into the static graph before esbuild splits chunks (merged post-build for IPFS).
import '@metamask/connect-evm';
import '@walletconnect/ethereum-provider';
import '@/wallet/universal-provider-shim';

import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

import 'chartjs-adapter-moment';

if (environment.production) enableProdMode();

bootstrapApplication(AppComponent, appConfig)
  .catch(err => console.error('Bootstrap error:', err));
